<template>
    <div class="rr-checkout__step rr-checkout__step_payment" v-show="active">
        <div class="uk-grid-small" uk-grid>
            <div class="uk-width-1-1 uk-text-center uk-text-left@m">
                <p class="uk-h3">{{ $t('rubinred.ecommerce.orders.checkout.step-3.title') }}</p>
            </div>
            <div class="uk-width-1-1">
                <div class="rr-checkout__wrapper">
                    <div class="rr-checkout__content">
                        <div slot="fields">
                            <custom-field ref="selectedPaymentCF" name="method" slug="method" :validations="['required']" :value="selectedPayment">
                                <ul ref="accordion" class="rr-checkout-accordion uk-margin-remove" slot="input" slot-scope="props">
                                    <li v-for="method in methods" class="rr-checkout-accordion__section">
                                        <div class="rr-checkout-accordion__title">
                                            <div class="rr-checkout-accordion__title-left">
                                                <label class="rr-checkout-accordion__title-label">
                                                    <input type="radio" class="uk-checkbox"
                                                           :name="props.name"
                                                           :disabled="!props.enabled"
                                                           :value="method.slug"
                                                           v-model="selectedPayment"
                                                           @change="props.setValue(method.slug); props.triggerChangeAndValidate()"
                                                           :class="{'uk-form-danger': props.isDanger, 'uk-form-success': props.isSuccess}">
                                                    <span class="rr-checkout-accordion__title-content">
                                                        <span class="rr-checkout-accordion__title-title">{{ method.name }}</span>
                                                    </span>
                                                </label>
                                            </div>
                                            <div class="rr-checkout-accordion__title-right">
                                                <!--<p>{{ $t('rubinred.ecommerce.orders.checkout.step-3.accordion_2_label') }}</p>-->
                                            </div>
                                        </div>
                                        <div class="rr-checkout-accordion__content uk-accordion-content">
                                            <p class="rr-checkout-accordion__content-title">{{ method.description }}</p>
                                            <component v-if="method.handler" :is="method.handler + 'Handler'" v-bind="method.data" :customer="customer" :ref="'handler_'+method.slug"></component>
                                        </div>
                                    </li>
                                </ul>
                            </custom-field>
                        </div>

                        <div class="uk-grid-small uk-margin-medium-top" uk-grid>
                            <div class="uk-width-1-1">
                                <label>
                                    <input class="uk-checkbox" type="checkbox" v-model="billing" @change="updateUikit()">
                                    {{ $t('rubinred.ecommerce.orders.checkout.step-2.invoice_request') }}
                                </label>
                            </div>
                            <div class="uk-width-1-1 case_fattura" v-show="billing">
                                <address-picker
                                        :customer="customer"
                                        name="billing"
                                        ref="picker"
                                        :initial-value="billingAddress"
                                        :allow-only-one-billing-address="allowOnlyOneBillingAddress"
                                        :previous-billing-address="previousBillingAddress"
                                        address-type="billing">
                                    <div class="uk-grid-small" uk-grid slot="form-fields">
                                        <div class="uk-width-1-1">
                                            <p class="rr-checkout-accordion__content-title">
                                                {{ $t('rubinred.ecommerce.orders.checkout.step-2.invoice_address') }}
                                            </p>
                                        </div>
                                        <slot></slot>
                                    </div>
                                </address-picker>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import CheckoutStep from 'rubinred/ecommerce/js/mixins/CheckoutStep'

  export default {
    mixins: [CheckoutStep],
    props: {
      allowOnlyOneBillingAddress: {
        type: Boolean,
        default: false,
      },
      previousBillingAddress: {
        type: Number,
      },
      methodsEndpoint: {
        type: String,
        required: true,
      },
      customer: {
        type: Boolean,
        required: true,
      }
    },
    data() {
      return {
        methods: {},
        accordion: null,
        selectedPayment: this.$store.state.checkout.payment.method ? this.$store.state.checkout.payment.method.slug : null,
        billing: !!this.$store.state.checkout.payment.billing,
        billingAddress: this.$store.state.checkout.payment.billing,
      };
    },
    watch: {
      selectedPayment() {
        this.accordion.toggle(this.methods.findIndex(method => method.slug === this.selectedPayment));
      },
      active() {
        if (this.active) {
          this.refreshMethods();
        }
      }
    },
    methods: {
      refreshMethods() {
        this.$root.$emit('checkout.toggle-loader');
        window.App.Axios.get(this.methodsEndpoint).then(response => {
          if (response.data.success) {
            this.methods = response.data.payment_methods;
            this.accordion = window.App.UIkit.accordion(this.$refs.accordion);
            if (this.selectedPayment) {
              this.$nextTick(() => {
                this.accordion.toggle(this.methods.findIndex(method => method.slug === this.selectedPayment));
              });
            }
          }
          this.$root.$emit('checkout.toggle-loader');
        });
      },

      submit() {
        if (!this.$refs.selectedPaymentCF.validateField()) {
          return false;
        }
        let data = {method: this.selectedPayment};

        let handlerPromise = null;
        if (Array.isArray(this.$refs['handler_' + this.selectedPayment])) { //get handler data
          handlerPromise = this.$refs['handler_' + this.selectedPayment][0].getData();
        }

        return Promise.resolve(handlerPromise).then(res => {
          if (res === false) {
            return {data: {success: false}};
          }
          data.handler = res;

          if (this.billing) {
            if (!this.$refs.picker.validate()) {
              return {data: {success: false}};
            }

            data = {...data, ...this.$refs.picker.getValues()};
          }

          return window.App.Axios.post(this.endpoint, data).then(response => {
            if (response.data.success) {
              this.$store.commit('cart/update', response.data.cart);
              this.$store.commit('checkout/setPaymentData', {
                method: this.methods.find(method => method.slug === this.selectedPayment),
                billing: response.data.billingAddress,
                handlerData: response.data.handlerData,
              });
            }

            return response;
          });
        });
      },

      updateUikit() {
        App.UIkit.update();
      }
    },
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/ecommerce/assets/js/components/checkout/steps/RubinredCheckoutPaymentStep.vue